
const Header = ({title}) => {
  return (
   <div className="h-[22px] lg:h-[107px] w-full bg-[#CC0B0B] flex justify-center items-center">
        <h1 className="text-[13px] lg:text-[49px] text-center text-[#FFFFFF]">
            {title}
        </h1>
      </div>
  )
}

export default Header